"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTiterInformationDto = instanceOfTiterInformationDto;
exports.TiterInformationDtoFromJSON = TiterInformationDtoFromJSON;
exports.TiterInformationDtoFromJSONTyped = TiterInformationDtoFromJSONTyped;
exports.TiterInformationDtoToJSON = TiterInformationDtoToJSON;
exports.TiterInformationDtoToJSONTyped = TiterInformationDtoToJSONTyped;
/**
 * Check if a given object implements the TiterInformationDto interface.
 */
function instanceOfTiterInformationDto(value) {
    if (!('titerPerformed' in value) || value['titerPerformed'] === undefined)
        return false;
    if (!('titerDate' in value) || value['titerDate'] === undefined)
        return false;
    return true;
}
function TiterInformationDtoFromJSON(json) {
    return TiterInformationDtoFromJSONTyped(json, false);
}
function TiterInformationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'titerPerformed': json['titerPerformed'],
        'titerDate': json['titerDate'],
    };
}
function TiterInformationDtoToJSON(json) {
    return TiterInformationDtoToJSONTyped(json, false);
}
function TiterInformationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'titerPerformed': value['titerPerformed'],
        'titerDate': value['titerDate'],
    };
}
//# sourceMappingURL=TiterInformationDto.js.map